import React, { useEffect } from "react";
import { MeasureVoltage } from "../../models/testSteps/measureVoltage.ts";
import { Voltage } from "../../models/signalUsers/voltage.ts";
import { TextField, Grid, FormControlLabel, Checkbox, MenuItem, InputAdornment } from "@mui/material";
import { getSignalLabel } from "../../utils/signalUtils.ts";

interface Props {
  data: MeasureVoltage;
  onChange: (updated: MeasureVoltage) => void;
  setIsValid: (valid: boolean) => void;
  voltageOptions: Voltage[];
}

const EditMeasureVoltageForm: React.FC<Props> = ({ data, onChange, setIsValid, voltageOptions }) => {
  useEffect(() => {
    const validId = voltageOptions.some(v => v.id === data.voltage_id);
    const minValid = !data.enable_min || data.min >= 0;
    const maxValid = !data.enable_max || data.max >= 0;
    const minMaxValid = (data.enable_min && data.enable_max && data.max < data.min)? false : true;
    setIsValid(data.name.trim() !== "" && validId && minValid && maxValid && minMaxValid);
  }, [data, voltageOptions, setIsValid]);

  const handleVoltageChange = (id: string) => {
    const voltage = voltageOptions.find(v => v.id === id);
    if (voltage) {
      const label = voltage ? getSignalLabel(voltage.signal) : "Not found";
      onChange({ ...data, voltage_id: id, voltage_name: label });
    }
  };

  
  return (
    <Grid container spacing={2} mt={1}>
      <Grid size={12}>
        <TextField
          label="Name"
          fullWidth
          value={data.name}
          onChange={(e) => onChange({ ...data, name: e.target.value })}
        />
      </Grid>
      <Grid size={12}>
        <TextField
          select
          fullWidth
          label="Spannungsmessung auswählen"
          value={data.voltage_id}
          onChange={(e) => handleVoltageChange(e.target.value)}
        >
          {voltageOptions.map((v) => (
            <MenuItem key={v.id} value={v.id}>{getSignalLabel(v.signal)}</MenuItem>
          ))}
        </TextField>
      </Grid>
      <Grid size={6}>
        <FormControlLabel
          control={
            <Checkbox
              checked={data.enable_min}
              onChange={(e) => onChange({ ...data, enable_min: e.target.checked })}
            />
          }
          label="Untergrenze aktiv"
        />
        <TextField
          label="Untergrenze"
          type="number"
          fullWidth
          value={data.min}
          inputProps={{ step: 0.01, min: 0 }}
          InputProps={{ endAdornment: <InputAdornment position="end">V</InputAdornment> }}
          onChange={(e) => onChange({ ...data, min: parseFloat(e.target.value) || 0 })}
          disabled={!data.enable_min}
        />
      </Grid>
      <Grid size={6}>
        <FormControlLabel
          control={
            <Checkbox
              checked={data.enable_max}
              onChange={(e) => onChange({ ...data, enable_max: e.target.checked })}
            />
          }
          label="Obergrenze aktiv"
        />
        <TextField
          label="Obergrenze"
          type="number"
          fullWidth
          value={data.max}
          inputProps={{ step: 0.01, min: 0 }}
          InputProps={{ endAdornment: <InputAdornment position="end">V</InputAdornment> }}
          onChange={(e) => onChange({ ...data, max: parseFloat(e.target.value) || 0 })}
          disabled={!data.enable_max}
        />
      </Grid>
    </Grid>
  );
};

export default EditMeasureVoltageForm;